import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";

const WaiverStepLayout = ({ children, waiver, currentStep, isReadOnly, readOnlyReason }) => {
  const navigate = useNavigate();

  /*5th June 2026: 
  *NEW*  I honestly do not think it is wise to open the full builder flow when someone views an archived waiver. It doesn’t make sense to me, because “Previous Step,” “Review & Publish,” and builder screens make it feel editable. Instead, what if we removed the builder altogether and created a read-only version similar to this: Video. Please let me know which things are unnecessary or wouldn’t be there, so I can create a sample for you without them
  Figma — I've created the Archived screens here. If something is extra, then please let me know. To clarify here, we would not be opening the waiver builder screens when viewing something that has been archived. */
  useEffect(() => {
    if (!waiver?._id) return;

    const isArchived =
      waiver.waiverStatus === "archived_by_admin" ||
      waiver.waiverStatus === "archived_by_new_version" ||
      waiver.waiverStatus === "archived_by_location_deletion";

    if (isArchived) {
      navigate(`/business/waiverviewer/${waiver._id}`, {
        replace: true,
      });
    }
  }, [waiver, navigate]);

  return (
    <div className="h-screen flex bg-background">
      <Sidebar />

      <div className="flex-1 relative flex flex-col">
        
        {/* Floating top-right notices */}
        <div className="flex px-8 pt-6">
          <div className="space-y-2 max-w-md w-full">
            
            {waiver?.waiverStatus === "new_version" && (
              <div className="bg-gray-50 border border-gray-200 text-gray-700 text-xs px-3 py-2 rounded-md font-medium">
                New Waiver Version.
                {/* <span
                  onClick={() =>
                    navigate(
                      `/business/waiverbuilder/smart/${waiver.versionOfWaiverId}/${currentStep}`
                    )
                  }
                  className="ml-2 text-blue-600 underline cursor-pointer"
                >
                  View Published Waiver
                </span> */}
              </div>
            )}

            {waiver?.waiverStatus === "published" && (
              <div className="bg-gray-50 border border-gray-200 text-gray-700 text-xs px-3 py-2 rounded-md font-medium">
                Published Waiver, Version {waiver?.version}.
                {waiver?.hasNewVersionInProgress && (
                  <span
                    onClick={() =>
                      /*navigate(
                        `/business/waiverbuilder/smart/${waiver.newVersionWaiverId}/${currentStep}`
                      )*/

                      navigate(
                        `/business/waivereditor/${waiver.newVersionWaiverId}`
                      )
                    }
                    className="ml-2 text-blue-600 underline cursor-pointer"
                  >
                    A new version in progress, click to edit & make live.
                  </span>
                )}
              </div>
            )}

            {isReadOnly && readOnlyReason && (
              <div className="bg-amber-50 border border-amber-200 text-amber-800 text-xs px-3 py-2 rounded-md">
                {readOnlyReason}
              </div>
            )}

          </div>
        </div>

        {/* Page content */}
        <div className="px-8 pt-10 pb-10">
          {children}
        </div>

      </div>
    </div>
  );
};

export default WaiverStepLayout;